(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-col"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const $sliders = $('#slider-wrapper1[data-enable-slider="true"]');

  $sliders.each(function() {
    const $wrapper = $(this);
    const $slider = $wrapper.find('.slider-track');
    const $navWrapper = $wrapper.find('.slider-nav-wrapper');
    const $prevBtn = $navWrapper.find('.slick-prev');
    const $nextBtn = $navWrapper.find('.slick-next');
    const $counter = $navWrapper.find('.slider-counter');
    const $progressBar = $wrapper.find('.slider-progress-bar');

    const slidesToShow = 3;
    const slidesToScroll = 1;

    if (!$slider.length) return;

    // ensure total is set from blocks (fallback to slick count after init)
    if ($counter.length) {
      $counter.find('.total').text($wrapper.find('.slider-track > *').length);
    }

    if (!$slider.hasClass('slick-initialized')) {
      // Initialize slick WITHOUT built-in arrows (we'll use custom buttons)
      $slider.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        arrows: false,          // disable slick arrows
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      // after init: set counter and progress
      $slider.on('init', function(event, slick) {
        const totalSlides = slick.slideCount;
        const currentIndex = slick.currentSlide + 1; // first visible slide index (1-based)
        if ($counter.length) {
          $counter.find('.current').text(currentIndex);
          $counter.find('.total').text(totalSlides);
        }
        updateProgress(slick.currentSlide, totalSlides);
      });

      // after each change update counter/progress
      $slider.on('afterChange', function(event, slick, currentSlide) {
        const totalSlides = slick.slideCount;
        const currentIndex = currentSlide + 1; // first visible slide index (1-based)
        if ($counter.length) {
          $counter.find('.current').text(currentIndex);
        }
        updateProgress(currentSlide, totalSlides);
      });

      // Custom prev/next button handlers (use existing DOM buttons)
      $prevBtn.on('click', function(e) {
        e.preventDefault();
        $slider.slick('slickPrev');
      });
      $nextBtn.on('click', function(e) {
        e.preventDefault();
        $slider.slick('slickNext');
      });

      // helper to set progress bar width
      function updateProgress(currentSlideIndex, totalSlides) {
        // compute progression based on the first visible slide index.
        // show progress as "how much of slides have been reached by viewport".
        // Example: with slidesToShow=3, currentSlideIndex=0 => visible 1-3 of total
        // We'll compute percentage = (firstVisibleIndex + slidesToShow - 1) / totalSlides
        const firstVisible = currentSlideIndex + 1;
        const lastVisible = Math.min(currentSlideIndex + slidesToShow, totalSlides);
        const progress = (lastVisible / totalSlides) * 100;
        if ($progressBar.length) {
          $progressBar.css('width', Math.min(Math.max(progress, 0), 100) + '%');
        }
      }

      // trigger init manually to ensure 'init' fires in all contexts
      $slider.slick('refresh');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-col1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const $sliders = $('.slider-wrapper[data-enable-slider="true"]');

  $sliders.each(function() {
    const $wrapper = $(this);
    const $slider = $wrapper.find('.slider-track');
    const $navWrapper = $wrapper.find('.slider-nav-wrapper');
    const $prevBtn = $navWrapper.find('.slick-prev');
    const $nextBtn = $navWrapper.find('.slick-next');
    const $counter = $navWrapper.find('.slider-counter');
    const $progressBar = $wrapper.find('.slider-progress-bar');

    if (!$slider.length) return;

    if ($counter.length) {
      $counter.find('.total').text($wrapper.find('.slider-track > *').length);
    }

    if (!$slider.hasClass('slick-initialized')) {
      $slider.on('init', function(event, slick) {
        const totalSlides = slick.slideCount;
        const currentIndex = slick.currentSlide + 1;
        if ($counter.length) {
          $counter.find('.current').text(currentIndex);
          $counter.find('.total').text(totalSlides);
        }
        updateProgress(slick.currentSlide, totalSlides);
      });

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        variableWidth: true, // ✅ Allows partial next slide
      });

      $slider.on('afterChange', function(event, slick, currentSlide) {
        const totalSlides = slick.slideCount;
        const currentIndex = currentSlide + 1;
        if ($counter.length) {
          $counter.find('.current').text(currentIndex);
        }
        updateProgress(currentSlide, totalSlides);
      });

      $prevBtn.on('click', function(e) {
        e.preventDefault();
        $slider.slick('slickPrev');
      });
      $nextBtn.on('click', function(e) {
        e.preventDefault();
        $slider.slick('slickNext');
      });

      function updateProgress(currentSlideIndex, totalSlides) {
        const progress = ((currentSlideIndex + 1) / totalSlides) * 100;
        if ($progressBar.length) {
          $progressBar.css('width', Math.min(Math.max(progress, 0), 100) + '%');
        }
      }

      $slider.slick('refresh');
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
